/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { CreditorInstitutionAddress } from "./CreditorInstitutionAddress";
import { withDefault } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

// required attributes
const CreditorInstitutionDetailsR = t.interface({
  address: CreditorInstitutionAddress,

  business_name: t.string,

  creditor_institution_code: t.string,

  enabled: withDefault(t.boolean, true),

  psp_payment: withDefault(t.boolean, true),

  reporting_ftp: withDefault(t.boolean, false),

  reporting_zip: withDefault(t.boolean, false)
});

// optional attributes
const CreditorInstitutionDetailsO = t.partial({
  cbill_code: t.string,

  description: t.string
});

export const CreditorInstitutionDetails = t.intersection(
  [CreditorInstitutionDetailsR, CreditorInstitutionDetailsO],
  "CreditorInstitutionDetails"
);

export type CreditorInstitutionDetails = t.TypeOf<
  typeof CreditorInstitutionDetails
>;
